import React from 'react'
import { Text, InternalLink, LinkMessageContainer } from './styled'

export const SignUpMessage = () => (
  <LinkMessageContainer>
    <Text style={{ marginRight: '0.4rem' }}>Don’t have an account?</Text>
    <InternalLink to="/sign-up">Sign up here!</InternalLink>
  </LinkMessageContainer>
)
